import React, { useState, useEffect, Fragment, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box, Card, Grid, TextField, makeStyles, Container, Button, CardContent, Divider, InputLabel,
  CardHeader, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Collapse, IconButton, Dialog, Typography
} from '@material-ui/core';
import Page from 'src/components/Page';
import services from '../Services';
import { useNavigate } from 'react-router-dom';
import { Formik } from 'formik';
import * as Yup from "yup";
import { useAlert } from "react-alert";
import { LoadingComponent } from 'src/utils/newLoader';
import { trackPromise } from 'react-promise-tracker';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import authService from 'src/utils/permissionAuth';
import tokenService from 'src/utils/tokenDecoder';
import { red, blue } from '@material-ui/core/colors';
import moment from 'moment';
import VisibilityIcon from '@material-ui/icons/Visibility';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import CreatePDF from './CreatePDF';
import ReactToPrint from 'react-to-print';
import xlsx from 'json-as-xlsx';
import CircularProgress from '@material-ui/core/CircularProgress';
import { CheckCircleOutline, ErrorOutline } from '@material-ui/icons';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  },
  cardroot: {
    minWidth: 275,
  },
  avatar: {
    marginRight: theme.spacing(2)
  },
  colorReject: {
    backgroundColor: "red",
  },
  colorCancel: {
    backgroundColor: "red",
  },
  colorApprove: {
    backgroundColor: "green",
  },
  card: {
    flexGrow: 10,
    backgroundColor: "#ffffff",
    paddingInlineStart: '10px',
    borderRadius: '10px',
  },
  avatar: {
    backgroundColor: red[500],
  },
  blue: {
    backgroundColor: blue[500],
  },
  succes: {
    backgroundColor: "#e8f5e9"
  },
  failed: {
    backgroundColor: "#fce4ec"
  },
  bold: {
    fontWeight: 600
  },
  stickyColumn: {
    position: 'sticky',
    left: 0,
    background: 'white',
    zIndex: 1,
    borderRight: '1px solid black',
  }
}));

const screenCode = 'ROUTEWISEBALANCEPAYMENTREPORT';

export default function BalanceRateAddEdit(props) {
  const [title, setTitle] = useState("Route Wise Balance Payment Report");
  const [isUpdate, setIsUpdate] = useState(false);
  const [groups, setGroups] = useState();
  const [factories, setFactories] = useState();
  const [products, setProducts] = useState();
  const [collectionTypeArray, setCollectionTypeArray] = useState([]);
  const [collectionTypeNameArray, setCollectionTypeNameArray] = useState([]);
  const [routeNameArray, setRouteNameArray] = useState([]);
  const [searchStarted, setSearchStarted] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isBalancePaymentCalculated, setIsBalancePaymentCalculated] = useState(false);
  const [isMaxEror, setIsMaxEror] = useState({});
  const [isMinEror, setIsMinEror] = useState({});
  const [isMaxEror2, setIsMaxEror2] = useState({});
  const [minErrorMsg, setMinErrorMsg] = useState({});
  const [maxErrorMsg, setMaxErrorMsg] = useState({});
  const [maxErrorMsg2, setMaxErrorMsg2] = useState({});
  const [isStartBalanceEstimationExecution, setStartBalanceEstimationExecution] = useState(false);
  const [isBalanceEstimationCompleted, setBalanceEstimationCompleted] = useState(false);
  const [isBalanceRatesInSession, setBalanceRatesInSession] = useState(false);
  const [supplierWiseBalancePaymentEstimationDetails, setSupplierWiseBalancePaymentEstimationDetails] = useState([]);
  const [routeWiseBalancePaymentEstimationDetails, setRouteWiseBalancePaymentEstimationDetails] = useState([]);
  const [selectedRouteSupplierWiseBalanceDetails, setSelectedRouteSupplierWiseBalanceDetails] = useState([]);
  const [displaySupplierWiseTable, setDisplaySupplierWiseTable] = useState(false);
  const [openWaitingAnimation, setOpenWaitingAnimation] = useState(false);
  const [backendProcessDone, setBackendProcessDone] = useState(false);
  const [timeOuted, setTimeOuted] = useState(false);
  const [selectedSearchValues, setSelectedSearchValues] = useState({
    groupName: '',
    factoryName: '',
    year: '',
    month: '',
    routeName: ''
  });
  const [permissionList, setPermissions] = useState({
    isGroupFilterEnabled: false,
    isFactoryFilterEnabled: false,
    isBalanceRateAddEdit: false,
    isBalanceRateApproveReject: false
  });
  const [collectionTypeRate, setCollectionTypeRate] = useState({
    groupID: 0,
    factoryID: 0,
    routeID: 0,
    productID: 0,
    collectionTypeID: 0,
    rate: '0',
  });
  const classes = useStyles();
  const navigate = useNavigate();
  const alert = useAlert();
  const componentRef = useRef();

  useEffect(() => {
    getPermissions();
    trackPromise(getGroupsForDropdown());
    SetBalanceRatesFromSession();
  }, []);

  useEffect(() => {
    let isMounted = true;
    const timeoutMs = 600000;
    const startTime = Date.now();

    async function backEndRequest() {
      if (!isMounted) return;

      if (sessionStorage.getItem("BalanceRateDetails") != null) {
        setOpenWaitingAnimation(true);
        const balanceRateDetails = JSON.parse(sessionStorage.getItem("BalanceRateDetails"));
        const response = await services.CheckBalanceEstimationExecutionStatus(balanceRateDetails.executionHistoryID);

        if (!isMounted) return;

        if (response.statusCode === 'Success') {
          if (response.data.executionStatusID == 3) {
            setBalanceEstimationCompleted(true);
            setCollectionTypeRate({
              ...collectionTypeRate,
              groupID: balanceRateDetails.groupID,
              factoryID: balanceRateDetails.factoryID
            });
            
            setBackendProcessDone(true);
            setTimeout(() => setOpenWaitingAnimation(false), 1000);
            return;
          } else {
            setStartBalanceEstimationExecution(true);
            setCollectionTypeRate({
              ...collectionTypeRate,
              groupID: balanceRateDetails.groupID,
              factoryID: balanceRateDetails.factoryID
            });
          }
        }
      }

      if (Date.now() - startTime < timeoutMs) {
        setTimeout(backEndRequest, 5000); // waiting for try again
      } else {
        setTimeOuted(true);
      }
    };

    backEndRequest();

    return () => {
      isMounted = false;
    };
  }, []);

  useEffect(() => {
    if (collectionTypeRate.groupID > 0) {
      trackPromise(getFactoriesForDropdown());
    }
  }, [collectionTypeRate.groupID]);

  useEffect(() => {
    if (collectionTypeRate.factoryID) {
      trackPromise(getProductsForDropdown());
    }

    if (collectionTypeRate.factoryID > 0 && collectionTypeRate.groupID > 0) {
      trackPromise(GetBalancePaymentYearMonthForDropDown());
    }

  }, [collectionTypeRate.factoryID]);

  useEffect(() => {
  }, [collectionTypeRate.productID]);

  useEffect(() => {
    if (collectionTypeRate.groupID > 0 && collectionTypeRate.factoryID > 0 && collectionTypeRate.productID > 0 && selectedDate !== null) {
      trackPromise(GetCollectionTypeBalanceRateDetails());
    }
  }, [selectedDate, collectionTypeRate.productID]);

  useEffect(() => {
    trackPromise(
      settingCollectionTypeName(),
      settingRouteName()
    );
  }, [collectionTypeArray]);

  useEffect(() => {
    setRouteWiseBalancePaymentEstimationDetails([]);
    setSelectedRouteSupplierWiseBalanceDetails([]);
    setSupplierWiseBalancePaymentEstimationDetails([]);
    setDisplaySupplierWiseTable(false);
  }, [collectionTypeRate.groupID, collectionTypeRate.factoryID, collectionTypeRate.productID, selectedDate]);

  async function getPermissions() {
    var permissions = await authService.getPermissionsByScreen(screenCode);
    var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITBALANCERATE' || p.permissionCode == 'BALANCERATEPERMISSION');

    if (isAuthorized === undefined) {
      navigate('/404');
    }

    var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
    var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');
    var isBalanceRateAddEdit = permissions.find(p => p.permissionCode === 'ADDEDITBALANCERATE');
    var isBalanceRateApproveReject = permissions.find(p => p.permissionCode === 'BALANCERATEPERMISSION');

    setPermissions({
      ...permissionList,
      isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
      isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
      isBalanceRateAddEdit: isBalanceRateAddEdit !== undefined,
      isBalanceRateApproveReject: isBalanceRateApproveReject !== undefined
    });

    setCollectionTypeRate({
      ...collectionTypeRate,
      groupID: parseInt(tokenService.getGroupIDFromToken()),
      factoryID: parseInt(tokenService.getFactoryIDFromToken()),
    });
  }

  async function settingCollectionTypeName() {
    var x = collectionTypeArray.map(item => item.collectionTypeName);
    var z = Array.from(new Set(x));
    setCollectionTypeNameArray(z);
  }

  async function settingRouteName() {
    var x = collectionTypeArray.map(item => item.routeName);
    var z = Array.from(new Set(x));
    setRouteNameArray(z);
  }

  async function getGroupsForDropdown() {
    const groups = await services.getAllGroups();
    setGroups(groups);
  }

  async function getFactoriesForDropdown() {
    const factories = await services.getAllFactoriesByGroupID(collectionTypeRate.groupID);
    setFactories(factories);
  }

  async function getProductsForDropdown() {
    const products = await services.getAllProducts(collectionTypeRate.factoryID);
    setProducts(products);
  }

  async function GetCollectionTypeBalanceRateDetails() {
    if (sessionStorage.getItem("BalanceRateDetails") == null) {
      const collectionTypes = await services.GetCollectionTypeBalanceRateDetails(collectionTypeRate.groupID,
        collectionTypeRate.factoryID,
        collectionTypeRate.productID, moment(selectedDate).format('L'));
      if (collectionTypes == null || collectionTypes == undefined || collectionTypes == "") {
        alert.error("No Records Found");
      } else {
        setIsBalancePaymentCalculated(collectionTypes.isBalancePaymentOccured);
        setCollectionTypeArray(collectionTypes.blanaceRates);
      }
    } else {
      SetBalanceRatesFromSession();
    }
  }

  function SetBalanceRatesFromSession() {
    if (sessionStorage.getItem("BalanceRateDetails") != null) {
      const balanceRateDetails = JSON.parse(sessionStorage.getItem("BalanceRateDetails"));
      setCollectionTypeArray(balanceRateDetails.collectionTypeBalanceRates);
      setBalanceRatesInSession(true);

      setCollectionTypeRate({
        ...collectionTypeRate,
        groupID: balanceRateDetails.groupID,
        factoryID: balanceRateDetails.factoryID,
      });
    }
  }

  async function calculateMonthlyBalance(collectionTypes, isBalancePaymentOccured) {

    if (collectionTypeRate.productID == 0) {
      return;
    }

    let formdata = {
      collectionTypeBalanceRates: collectionTypes === null || collectionTypes.length === 0 ? collectionTypeArray : collectionTypes,
      groupID: parseInt(collectionTypeRate.groupID),
      factoryID: parseInt(collectionTypeRate.factoryID),
      applicableDate: moment(selectedDate).format(),
      applicableMonth: (selectedDate.getMonth() + 1).toString().padStart(2, '0'),
      applicableYear: selectedDate.getFullYear().toString(),
      isBalancePaymentCalculated: isBalancePaymentOccured === null ? isBalancePaymentCalculated : isBalancePaymentOccured
    }

    let response = await services.calculateMonthlyBalance(formdata);

    if (response.statusCode === 'Success') {
      let balanceRateDetails = {
        ...formdata,
        executionHistoryID: response.data
      }
      sessionStorage.setItem("BalanceRateDetails", JSON.stringify(balanceRateDetails));
      window.location.reload();
    } else {
      alert.error("Error ocured when calculate monthly balance");
    }
  }

  function generateDropDownMenu(data) {
    let items = []
    if (data != null) {
      for (const [key, value] of Object.entries(data)) {
        items.push(<MenuItem key={key} value={key}>{value}</MenuItem>)
      }
    }
    return items
  }

  function handleChange(e) {
    const target = e.target;
    const value = target.value
    setCollectionTypeRate({
      ...collectionTypeRate,
      [e.target.name]: value
    });
    setCollectionTypeArray([]);
  }

  function handleRateChange(e, routeName, index, collectionTypeName) {
    const target = e.target;
    const value = target.value;

    const copycollectionTypeArray = [...collectionTypeArray];
    var idx = copycollectionTypeArray.findIndex(e => (e.routeName === routeName && e.collectionTypeName === collectionTypeName));
    copycollectionTypeArray[idx] = { ...copycollectionTypeArray[idx], rate: parseFloat(value) };
    if (collectionTypeName === "Super Leaf") {
      checkSuperLeaf(value, index, collectionTypeName)
      copycollectionTypeArray[idx] = { ...copycollectionTypeArray[idx], rate: parseFloat(value) };
    } else if (collectionTypeName === "Normal Leaf") {
      checkNormalLeaf(value, index, collectionTypeName)
      copycollectionTypeArray[idx] = { ...copycollectionTypeArray[idx], rate: parseFloat(value) };
    } else if (collectionTypeName === "Golden Leaf") {
      checkGoldenLeaf(value, index, collectionTypeName)
      copycollectionTypeArray[idx] = { ...copycollectionTypeArray[idx], rate: parseFloat(value) };
    }
    setCollectionTypeArray(copycollectionTypeArray);
  }

  function handleAllRateChange(e, index, collectionTypeName) {
    const target = e.target;
    const value = target.value;
    if (value < 0) {
      return 0;
    }
    else {
      const copycollectionTypeArray = [...collectionTypeArray];
      var idx = copycollectionTypeArray.findIndex(e => e.collectionTypeName === collectionTypeName);
      copycollectionTypeArray[idx] = { ...copycollectionTypeArray[idx], rate: parseFloat(value) };

      for (let index = 0; index < copycollectionTypeArray.length; index++) {
        if (copycollectionTypeArray[index].collectionTypeName == collectionTypeName) {
          copycollectionTypeArray[index] = { ...copycollectionTypeArray[index], rate: parseFloat(value) };
        }
      }

      if (collectionTypeName === "Super Leaf") {
        for (let index = 0; index < copycollectionTypeArray.length; index++) {
          if (copycollectionTypeArray[index].collectionTypeName == collectionTypeName) {
            copycollectionTypeArray[index] = { ...copycollectionTypeArray[index], rate: parseFloat(value) };
          }
        }
      } else if (collectionTypeName === "Normal Leaf") {
        for (let index = 0; index < copycollectionTypeArray.length; index++) {
          if (copycollectionTypeArray[index].collectionTypeName == collectionTypeName) {
            copycollectionTypeArray[index] = { ...copycollectionTypeArray[index], rate: parseFloat(value) };
          }
        }
        copycollectionTypeArray[idx] = { ...copycollectionTypeArray[idx], rate: parseFloat(value) };
      }
      else if (collectionTypeName === "Golden Leaf") {
        for (let index = 0; index < copycollectionTypeArray.length; index++) {
          if (copycollectionTypeArray[index].collectionTypeName == collectionTypeName) {
            copycollectionTypeArray[index] = { ...copycollectionTypeArray[index], rate: parseFloat(value) };
          }
        }
        copycollectionTypeArray[idx] = { ...copycollectionTypeArray[idx], rate: parseFloat(value) };
      }
      setCollectionTypeArray(copycollectionTypeArray);
    }
  }

  function checkSuperLeaf(value, id, collectionTypeName) {
    var pattern = /^[0-9]+([.][0-9]{0,2})?$/;

    var copyOfMinErrMsgs = minErrorMsg;
    var copyOfIsMinEror = isMinEror;

    copyOfIsMinEror[id] = id;
    setIsMinEror(copyOfIsMinEror);

    if (value < 0) {
      copyOfMinErrMsgs[id] = "Super leaf rate need to be a positive number.";
    } else if (value.length > 8) {
      copyOfMinErrMsgs[id] = "Super leaf rate length exceeded.";
    } else if (value.length === 0) {
      copyOfMinErrMsgs[id] = "Super leaf rate is required.";
    } else if (!pattern.test(value.toString())) {
      copyOfMinErrMsgs[id] = "Super leaf rate only allow numbers and numbers with atmost 2 decimal points.";
    } else {
      copyOfMinErrMsgs[id] = "";

      copyOfIsMinEror[id] = -1;
      copyOfIsMinEror["collectionType"] = collectionTypeName;
      setIsMinEror(copyOfIsMinEror);
    }

    setMinErrorMsg(copyOfMinErrMsgs);
  }

  function checkNormalLeaf(value, id, collectionTypeName) {

    var pattern = /^[0-9]+([.][0-9]{0,2})?$/;

    var copyOfMaxErrMsgs = maxErrorMsg;
    var copyOfIsMaxEror = isMaxEror;

    copyOfIsMaxEror[id] = id;
    setIsMaxEror(copyOfIsMaxEror);

    if (value < 0) {
      copyOfMaxErrMsgs[id] = "Normal leaf rate need to be a positive number.";
    } else if (value.length > 8) {
      copyOfMaxErrMsgs[id] = "Normal leaf rate length exceeded.";
    } else if (value.length === 0) {
      copyOfMaxErrMsgs[id] = "Normal leaf rate is required.";
    } else if (!pattern.test(value.toString())) {
      copyOfMaxErrMsgs[id] = "Normal leaf rate only allow numbers and numbers with atmost 2 decimal points.";
    } else {
      copyOfMaxErrMsgs[id] = "";
      copyOfIsMaxEror[id] = -1;
      copyOfIsMaxEror["collectionType"] = collectionTypeName;
      setIsMaxEror(copyOfIsMaxEror);
    }
    setMaxErrorMsg(copyOfMaxErrMsgs);
  }

  function checkGoldenLeaf(value, id, collectionTypeName) {
    var pattern = /^[0-9]+([.][0-9]{0,2})?$/;

    var copyOfMaxErrMsgs = maxErrorMsg2;
    var copyOfIsMaxEror = isMaxEror2;

    copyOfIsMaxEror[id] = id;
    setIsMaxEror2(copyOfIsMaxEror);

    if (value < 0) {
      copyOfMaxErrMsgs[id] = "Golden leaf rate need to be a positive number.";
    } else if (value.length > 8) {
      copyOfMaxErrMsgs[id] = "Golden leaf rate length exceeded.";
    } else if (value.length === 0) {
      copyOfMaxErrMsgs[id] = "Golden leaf rate is required.";
    } else if (!pattern.test(value.toString())) {
      copyOfMaxErrMsgs[id] = "Golden leaf rate only allow numbers and numbers with atmost 2 decimal points.";
    } else {
      copyOfMaxErrMsgs[id] = "";
      copyOfIsMaxEror[id] = -1;
      copyOfIsMaxEror["collectionType"] = collectionTypeName;
      setIsMaxEror2(copyOfIsMaxEror);
    }
    setMaxErrorMsg2(copyOfMaxErrMsgs);
  }

  function handleDateChange(date) {
    var month = date.getUTCMonth() + 1; //months from 1-12
    var year = date.getUTCFullYear();
    var currentmonth = moment().format('MM');

    if (selectedDate != null) {
      var prevMonth = selectedDate.getUTCMonth() + 1
      var prevyear = selectedDate.getUTCFullYear();

      if ((prevyear == year && prevMonth != month) || (prevyear != year)) {
        setSelectedDate(date)
        setSearchStarted(true)
      }
    } else {
      setSelectedDate(date)
      setSearchStarted(true)
    }

  }

  function SettingValue(data, data1) {
    var x = collectionTypeArray.filter(x => x.routeName == data);
    var y = x.filter(x => x.collectionTypeName == data1);
    return y[0].rate;
  }

  function SettingValue1(data) {
    var x = collectionTypeArray.filter(x => x.collectionTypeName == data);
    return x.rate;
  }

  function cardTitle(titleName) {
    return (
      <Grid container spacing={1}>
        <Grid item md={10} xs={12}>
          {titleName}
        </Grid>
      </Grid>
    )
  }

  function renderRouteBalanceEstimationDetails(data) {
    const columns = [
      { id: "routeName", label: "Route" },
      { id: "totalNetWeight", label: "Crop Weight (KG)" },
      { id: "gross", label: "Gross" },
      { id: "totalAddition", label: "Addition Pay" },
      { id: "coinBF", label: "Coins" },
      { id: "transport", label: "Transport" },
      { id: "debtsBF", label: "B/F Debts" },
      { id: "fertilizerBF", label: "B/F Fertilizer" },
      { id: "advancePayment", label: "Advance" },
      { id: "teaDeduction", label: "Tea" },
      { id: "fertilizerDeductions", label: "Fertilizer" },
      { id: "festivalAdvance", label: "Festival Advance" },
      { id: "chemicalDeductions", label: "Chemical" },
      { id: "mealDeduction", label: "Meal" },
      { id: "loanPayment", label: "Loan" },
      { id: "stamp", label: "Stamp" },
      { id: "otherDeductions", label: "Other" },
      { id: "bankCharge", label: "Bank Charge" },
      { id: "totalDeductions", label: "Total Deductions" },
      { id: "balance", label: "Balance" },
      { id: "debtsCF", label: "C/F Debts" },
      { id: "fertilizerCF", label: "C/F Fertilizer" },
      { id: "loanBalance", label: "Loan Balance" },
      { id: "cash", label: "Cash" },
      { id: "bank", label: "Bank" },
      { id: "coinCF", label: "C/F Coins" },
      { id: "action", label: "Action" }
    ];

    const totals = columns.reduce((acc, column) => {
      if (column.id !== "routeName" || column.id !== "action") {
        acc[column.id] = data.reduce((sum, row) => sum + (row[column.id] || 0), 0);
      }
      return acc;
    }, {});

    return (
      <Box minWidth={1050} hidden={false}>
        <TableContainer component={Paper} style={{ maxHeight: '550px', overflowY: 'auto' }}>
          <Table size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    className={column.sticky ? classes.stickyColumn : ""}
                    style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }}
                    align="center"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      className={column.sticky ? classes.stickyColumn : ""}
                      style={{ border: "1px solid black" }}
                      align={typeof (row[column.id]) === "number" ? "right" : "left"}
                    >
                      {column.id === "action" ? (
                        <IconButton onClick={() => viewSupplierWiseBalanceDetails(row.routeID)}>
                          <VisibilityIcon />
                        </IconButton>
                      ) : (
                        typeof (row[column.id]) === 'string' ?
                          row[column.id] :
                          Number(row[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              ))}
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    className={column.sticky ? classes.stickyColumn : ""}
                    style={{ border: "1px solid black", fontWeight: "bold" }}
                    align={typeof (totals[column.id]) === "number" ? "right" : "left"}
                  >
                    {column.id === "routeName"
                      ? "Total"
                      : column.id === "action"
                        ? " "
                        : Number(totals[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  function renderSupplierBalanceEstimationDetails(data) {
    const columns = [
      { id: "registrationNumber", label: "Reg. No." },
      { id: "customerName", label: "Supplier Name" },
      { id: "totalNetWeight", label: "Crop Weight (KG)" },
      { id: "gross", label: "Gross" },
      { id: "totalAddition", label: "Addition Pay" },
      { id: "coinBF", label: "Coins" },
      { id: "transport", label: "Transport" },
      { id: "debtsBF", label: "B/F Debts" },
      { id: "fertilizerBF", label: "B/F Fertilizer" },
      { id: "advancePayment", label: "Advance" },
      { id: "teaDeduction", label: "Tea" },
      { id: "fertilizerDeductions", label: "Fertilizer" },
      { id: "festivalAdvance", label: "Festival Advance" },
      { id: "chemicalDeductions", label: "Chemical" },
      { id: "mealDeduction", label: "Meal" },
      { id: "loanPayment", label: "Loan" },
      { id: "stamp", label: "Stamp" },
      { id: "otherDeductions", label: "Other" },
      { id: "bankCharge", label: "Bank Charge" },
      { id: "totalDeductions", label: "Total Deductions" },
      { id: "balance", label: "Balance" },
      { id: "debtsCF", label: "C/F Debts" },
      { id: "fertilizerCF", label: "C/F Fertilizer" },
      { id: "loanBalance", label: "Loan Balance" },
      { id: "cash", label: "Cash" },
      { id: "bank", label: "Bank" },
      { id: "coinCF", label: "C/F Coins" }
    ];

    let collectionTypeIDArray = [];
    data.map((item) => {
      item.cropDetails.forEach(element => {
        collectionTypeIDArray.push({ collectionTypeID: element.collectionTypeID, collectionTypeName: element.collectionTypeName + ' Rate' });
      });
    });

    const collectionTypeIDs = [...new Map(collectionTypeIDArray.map(item => [item['collectionTypeID'], item])).values()];

    collectionTypeIDs.map((item) => {
      columns.splice(2, 0, { id: item.collectionTypeID, label: item.collectionTypeName })
    })

    const totals = columns.reduce((acc, column) => {
      if (column.id !== "registrationNumber" || column.id !== "customerName") {
        acc[column.id] = data.reduce((sum, row) => sum + (row[column.id] || 0), 0);
      }
      return acc;
    }, {});

    return (
      <Box minWidth={1050} hidden={false}>
        <Box display="flex" justifyContent="flex-start" p={2}>
          <Button
            color="secondary"
            variant="contained"
            size="medium"
            startIcon={<ArrowBackIcon />}
            onClick={() => handleGoBack()}
          >
          </Button>
        </Box>
        <TableContainer component={Paper} style={{ maxHeight: '550px', overflowY: 'auto' }}>
          <Table size="small" aria-label="simple table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    className={column.sticky ? classes.stickyColumn : ""}
                    style={{ border: "1px solid black", fontWeight: "bold", fontSize: "16px" }}
                    align="center"
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  {columns.map((column) => (
                    typeof (column.id) === "number" ? (
                      <TableCell
                        key={column.id}
                        className={column.sticky ? classes.stickyColumn : ""}
                        style={{ border: "1px solid black" }}
                        align='right'
                      >
                        {(() => {
                          const balanceRateObj = row.balanceRates.find(item => item.collectionTypeID == column.id);
                          const rate = balanceRateObj?.rate !== undefined
                            ? Number(balanceRateObj.rate).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                            : "0";
                          return rate;
                        })()}
                      </TableCell>
                    ) :
                      (<TableCell
                        key={column.id}
                        className={column.sticky ? classes.stickyColumn : ""}
                        style={{ border: "1px solid black" }}
                        align={typeof (row[column.id]) === "number" ? "right" : "left"}
                      >
                        {
                          column.id === "registrationNumber" || column.id === "customerName" ?
                            row[column.id] :
                            Number(row[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                        }
                      </TableCell>)
                  ))}
                </TableRow>
              ))}
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    className={column.sticky ? classes.stickyColumn : ""}
                    style={{ border: "1px solid black", fontWeight: "bold" }}
                    align={typeof (totals[column.id]) === "number" ? "right" : "left"}
                  >
                    {column.id === "registrationNumber"
                      ? "Total"
                      : column.id === "customerName"
                        ? " "
                        : typeof (column.id) === "number" ? " " :
                          Number(totals[column.id]).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </TableCell>
                ))}
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    );
  }

  function getSelectedDropdownValuesForReport(searchForm, factorieslist) {
    setSelectedSearchValues({
      ...selectedSearchValues,
      groupName: groups[searchForm.groupID],
      factoryName: factorieslist[searchForm.factoryID],
      year: searchForm.year,
      month: searchForm.month
    })
  }

  function viewSupplierWiseBalanceDetails(routeID) {
    const selectedRouteDetails = supplierWiseBalancePaymentEstimationDetails
      .filter(item => item.routeID == routeID)
      .sort((a, b) => a.registrationNumber - b.registrationNumber);
    setSelectedRouteSupplierWiseBalanceDetails(selectedRouteDetails);
    setDisplaySupplierWiseTable(true);

    setSelectedSearchValues({
      ...selectedSearchValues,
      routeName: (routeWiseBalancePaymentEstimationDetails.find(item => item.routeID == routeID)).routeName
    })
  }

  function handleGoBack() {
    setSelectedRouteSupplierWiseBalanceDetails([]);
    setDisplaySupplierWiseTable(false);
    setSelectedSearchValues({
      ...selectedSearchValues,
      routeName: ''
    })
  }

  async function getBalancePaymentEstimation() {
    const balanceRateDetails = JSON.parse(sessionStorage.getItem("BalanceRateDetails"));
    let response = await services.getBalancePaymentEstimation(balanceRateDetails);
    if (response.statusCode === 'Success') {
      setBalanceRatesInSession(false);
      sessionStorage.removeItem("BalanceRateDetails");
      setBalanceEstimationCompleted(false);
      setStartBalanceEstimationExecution(false);
      setSupplierWiseBalancePaymentEstimationDetails(response.data.supplierWiseBalancePaymentEstimation);
      setRouteWiseBalancePaymentEstimationDetails(response.data.routeWiseBalancePaymentEstimation);

      const factories = await services.getAllFactoriesByGroupID(balanceRateDetails.groupID);

      let model = {
        groupID: parseInt(balanceRateDetails.groupID),
        factoryID: parseInt(balanceRateDetails.factoryID),
        year: balanceRateDetails.applicableYear,
        month: new Date(2000, parseInt(balanceRateDetails.applicableMonth) - 1).toLocaleString('en-US', { month: 'long' })
      }

      getSelectedDropdownValuesForReport(model, factories);
    } else {
      alert.error(response.message);
    }
  }

  const getPageMargins = () => {
    return `@media print {
        @page {
            size: landscape !important;
            background-color: white !important;
        }
        body {
            transform-origin: top left;
            background-color: white !important;
        }
    }`;
  };

  async function createDataForExcel(array, dataType) {
    let res = [];

    if (!array) return res;

    let totals = {};

    array.forEach(row => {
      let formattedRow = {};

      if (dataType === 'supplierWise') {
        formattedRow = {
          'Reg. No.': row.registrationNumber,
          'Supplier Name': row.customerName,
        };

        row.balanceRates.forEach(rate => {
          formattedRow[rate.collectionTypeName + ' Rate'] = rate.rate;
        });

        Object.assign(formattedRow, {
          'Crop Weight (KG)': row.totalNetWeight,
          'Gross': row.gross,
          'Addition Pay': row.totalAddition,
          'Coins': row.coinBF,
          'Transport': row.transport,
          'B/F Debts': row.debtsBF,
          'B/F Fertilizer': row.fertilizerBF,
          'Advance': row.advancePayment,
          'Tea': row.teaDeduction,
          'Fertilizer': row.fertilizerDeductions,
          'Festival Advance': row.festivalAdvance,
          'Chemical': row.chemicalDeductions,
          'Meal': row.mealDeduction,
          'Loan': row.loanPayment,
          'Stamp': row.stamp,
          'Other': row.otherDeductions,
          'Bank Charge': row.bankCharge,
          'Total Deductions': row.totalDeductions,
          'Balance': row.balance,
          'C/F Debts': row.debtsCF,
          'C/F Fertilizer': row.fertilizerCF,
          'Loan Balance': row.loanBalance,
          'Cash': row.cash,
          'Bank': row.bank,
          'C/F Coins': row.coinCF
        });

      } else {
        formattedRow = {
          'Route': row.routeName,
          'Crop Weight (KG)': row.totalNetWeight,
          'Gross': row.gross,
          'Addition Pay': row.totalAddition,
          'Coins': row.coinBF,
          'Transport': row.transport,
          'B/F Debts': row.debtsBF,
          'B/F Fertilizer': row.fertilizerBF,
          'Advance': row.advancePayment,
          'Tea': row.teaDeduction,
          'Fertilizer': row.fertilizerDeductions,
          'Festival Advance': row.festivalAdvance,
          'Chemical': row.chemicalDeductions,
          'Meal': row.mealDeduction,
          'Loan': row.loanPayment,
          'Stamp': row.stamp,
          'Other': row.otherDeductions,
          'Bank Charge': row.bankCharge,
          'Total Deductions': row.totalDeductions,
          'Balance': row.balance,
          'C/F Debts': row.debtsCF,
          'C/F Fertilizer': row.fertilizerCF,
          'Loan Balance': row.loanBalance,
          'Cash': row.cash,
          'Bank': row.bank,
          'C/F Coins': row.coinCF
        };
      }

      Object.keys(formattedRow).forEach(key => {
        if (typeof formattedRow[key] === 'number') {
          totals[key] = (totals[key] || 0) + formattedRow[key];
        }
      });

      res.push(formattedRow);
    });

    var totalRow = { 'Reg. No.': 'Total', 'Supplier Name': '', 'Route': 'Total' };
    Object.keys(totals).forEach(key => {
      if (key !== 'Reg. No.' && key !== 'Supplier Name') {
        totalRow[key] = totals[key];
      }

      if (key.match(/Rate$/)) {
        totalRow[key] = '';
      }
    });

    res.push(totalRow);

    var vr1 = {
      [dataType === 'supplierWise' ? 'Reg. No.' : 'Route']: 'Group :' + selectedSearchValues.groupName,
      [dataType === 'supplierWise' ? 'Supplier Name' : 'Crop Weight (KG)']: 'Factory :' + selectedSearchValues.factoryName,
    };

    res.push(vr1);

    var vr2 = {
      [dataType === 'supplierWise' ? 'Reg. No.' : 'Route']: selectedSearchValues.routeName.length === 0 ? 'Route : ' + 'All Routes' : 'Route : ' + selectedSearchValues.routeName,
      [dataType === 'supplierWise' ? 'Supplier Name' : 'Crop Weight (KG)']: 'Year And Month : ' + selectedSearchValues.year + " - " + selectedSearchValues.month,
    }

    res.push(vr2);

    return res;
  }

  async function createFile() {
    const dataType = displaySupplierWiseTable ? "supplierWise" : "routeWise";

    const file = await createDataForExcel(dataType === 'supplierWise' ? selectedRouteSupplierWiseBalanceDetails : routeWiseBalancePaymentEstimationDetails, dataType);

    if (!file.length) return;

    const sheetName = dataType ===
      'supplierWise' ? "Route Wise Balance Payment Detail Report" : "Route Wise Balance Payment Summary Report";

    const fileName = 'supplierWise' ? (sheetName + ' ' + selectedSearchValues.month + ' - ' + selectedSearchValues.year + ' ' + selectedSearchValues.factoryName + ' ' + selectedSearchValues.routeName) :
      (sheetName + ' ' + selectedSearchValues.month + ' - ' + selectedSearchValues.year + ' ' + selectedSearchValues.factoryName);

    let keys = Object.keys(file[0]);
    let tempCsvHeaders = keys.map(sitem => ({ label: sitem, value: sitem }));

    let dataA = [
      {
        sheet: 'Route Wise Balance Payment',
        columns: tempCsvHeaders,
        content: file
      }
    ];

    xlsx(dataA, { sheetName, fileName, writeOptions: {} });
  }

  async function GetBalancePaymentYearMonthForDropDown() {
    var response = await services.GetBalancePaymentYearMonth(collectionTypeRate.groupID, collectionTypeRate.factoryID);

    const applicableYear = parseInt(response.applicableYear);
    const applicableMonth = parseInt(response.applicableMonth) - 1;

    const selectedDate = new Date(applicableYear, applicableMonth);

    setSelectedDate(selectedDate);
  };

  return (
    <Fragment>
      <LoadingComponent />
      <Page className={classes.root} title={title}>
        <Container maxWidth={false}>
          <Formik
            initialValues={{
              groupID: collectionTypeRate.groupID,
              factoryID: collectionTypeRate.factoryID,
              routeID: collectionTypeRate.routeID,
              productID: collectionTypeRate.productID,
              collectionTypeID: collectionTypeRate.collectionTypeID,
              selectedDate: selectedDate
            }}
            validationSchema={
              Yup.object().shape({
                groupID: Yup.number().required('Group required').min("1", 'Group required'),
                factoryID: Yup.number().required('Factory required').min("1", 'Factory required'),
                routeID: Yup.number().required('Route required').min("1", 'Route required'),
                productID: Yup.number().required('Product required').min("1", 'Product required'),
                selectedDate: Yup.date().required('Select applicable month').nullable(),
              })
            }
            enableReinitialize
          >
            {({
              errors,
              handleBlur,
              handleSubmit,
              isSubmitting,
              touched,
              values
            }) => (
              <form onSubmit={handleSubmit}>
                <Box mt={0}>
                  <Card>
                    <CardHeader
                      title={cardTitle(title)}
                    />
                    <PerfectScrollbar>
                      <Divider />
                      <CardContent>
                        <Grid container spacing={3}>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="groupID">
                              Group *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.groupID && errors.groupID)}
                              fullWidth
                              helperText={touched.groupID && errors.groupID}
                              disabled={isBalanceRatesInSession}
                              name="groupID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={values.groupID}
                              variant="outlined"
                              id="groupID"
                              InputProps={{
                                readOnly: isUpdate || !permissionList.isGroupFilterEnabled ? true : false
                              }}
                              size='small'
                            >
                              <MenuItem value="0">--Select Group--</MenuItem>
                              {generateDropDownMenu(groups)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="factoryID">
                              Factory *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.factoryID && errors.factoryID)}
                              fullWidth
                              helperText={touched.factoryID && errors.factoryID}
                              disabled={isBalanceRatesInSession}
                              name="factoryID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={values.factoryID}
                              variant="outlined"
                              id="factoryID"
                              InputProps={{
                                readOnly: isUpdate || !permissionList.isFactoryFilterEnabled ? true : false
                              }}
                              size='small'
                            >
                              <MenuItem value="0">--Select Factory--</MenuItem>
                              {generateDropDownMenu(factories)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={8}>
                            <InputLabel shrink id="productID">
                              Product *
                            </InputLabel>
                            <TextField select
                              error={Boolean(touched.productID && errors.productID)}
                              fullWidth
                              helperText={touched.productID && errors.productID}
                              disabled={isBalanceRatesInSession}
                              name="productID"
                              onBlur={handleBlur}
                              onChange={(e) => handleChange(e)}
                              value={values.productID}
                              variant="outlined"
                              id="productID"
                              InputProps={{
                                readOnly: isUpdate ? true : false
                              }}
                              size='small'
                            >
                              <MenuItem value="0">--Select Product--</MenuItem>
                              {generateDropDownMenu(products)}
                            </TextField>
                          </Grid>

                          <Grid item md={3} xs={12}>
                            <MuiPickersUtilsProvider utils={DateFnsUtils}>
                              <DatePicker
                                error={Boolean(touched.selectedDate && errors.selectedDate)}
                                fullWidth
                                helperText={touched.selectedDate && errors.selectedDate}
                                autoOk
                                variant="inline"
                                openTo="month"
                                views={["year", "month"]}
                                label="Year and Month *"
                                value={values.selectedDate}
                                onChange={(date) => handleDateChange(date)}
                                size='small'
                                disabled={isBalanceRatesInSession}
                              />
                            </MuiPickersUtilsProvider>
                          </Grid>

                        </Grid>
                        <br />
                        {(collectionTypeArray.length > 0) ?
                          <Grid item md={12} xs={12}>
                            <Grid className={classes.container}>
                              <Collapse in={true}>
                                <Paper elevation={0} className={classes.paper}>
                                  <Grid container spacing={4}>
                                    <Grid item xs={12}>
                                      <TableContainer >
                                        <Table className={classes.table} aria-label="caption table">
                                          <TableHead>
                                            <TableRow>
                                              <TableCell align={'center'}>Routes</TableCell>
                                              {collectionTypeNameArray.map((data, index) =>
                                              (
                                                <TableCell align={'right'}>
                                                  <Box display='flex' alignItems='center' justifyContent='center'>
                                                    <Box>{data + ' Rate'}</Box>
                                                    <Box ml={1}>
                                                      <TextField
                                                        error={Boolean(touched.rate && errors.rate)}
                                                        helperText={touched.rate && errors.rate}
                                                        name='allrate'
                                                        onBlur={handleBlur}
                                                        alignContent='center'
                                                        onChange={(e) => handleAllRateChange(e, index, data)}
                                                        value={SettingValue1(data)}
                                                        type='number'
                                                        variant='outlined'
                                                        size='small'
                                                        style={{ width: '100px' }}
                                                        inputProps={{ style: { textAlign: 'center' } }}
                                                        disabled={isBalanceRatesInSession}
                                                      />
                                                    </Box>
                                                  </Box>
                                                </TableCell>
                                              ))}
                                            </TableRow>
                                          </TableHead>
                                          <TableBody>
                                            {routeNameArray.map((data, index) => (
                                              <TableRow key={index}>
                                                <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                  {data}
                                                </TableCell>
                                                {collectionTypeNameArray.map((data1, index1) => (
                                                  <TableCell align={'center'} component="th" scope="row" style={{ borderBottom: "none" }}>
                                                    <Grid alignContent={'center'}  >
                                                      <TextField
                                                        error={Boolean(touched.rate && errors.rate)}
                                                        helperText={touched.rate && errors.rate}
                                                        name="rate"
                                                        onBlur={handleBlur}
                                                        alignContent='center'
                                                        onChange={(e) => handleRateChange(e, data, index, data1)}
                                                        value={SettingValue(data, data1)}
                                                        type='number'
                                                        variant="outlined"
                                                        size='small'
                                                        inputProps={{ style: { textAlign: 'center' } }}
                                                        disabled={isBalanceRatesInSession}
                                                      />
                                                    </Grid>
                                                    {data1 === "Super Leaf" ? (parseInt(isMinEror[index]) === parseInt(index)) || (isMinEror["collectionType"] === data1) ?
                                                      <small style={{ color: 'red', wordWrap: 'break-word' }}>{minErrorMsg[index]}</small> : null
                                                      : data1 === "Normal Leaf" ? (parseInt(isMaxEror[index]) === parseInt(index)) || (isMaxEror["collectionType"] === data1) ?
                                                        <small style={{ color: 'red', wordWrap: 'break-word' }}>{maxErrorMsg[index]}</small> : null
                                                        : (parseInt(isMaxEror2[index]) === parseInt(index)) || (isMaxEror2["collectionType"] === data1) ?
                                                          <small style={{ color: 'red', wordWrap: 'break-word' }}>{maxErrorMsg2[index]}</small> : null}
                                                  </TableCell>
                                                ))}
                                              </TableRow>
                                            ))}
                                          </TableBody>
                                        </Table>
                                      </TableContainer>
                                    </Grid>
                                  </Grid>
                                </Paper>
                              </Collapse>
                            </Grid>
                          </Grid>
                          :
                          <Box paddingTop="20px"
                            hidden={!searchStarted}  >
                            {"- No records found. -"}
                          </Box>
                        }
                        {
                          isBalanceEstimationCompleted === false ?
                            <Box display="flex" justifyContent="flex-end" p={2}>
                              <Button
                                color="primary"
                                disabled={isStartBalanceEstimationExecution}
                                type="submit"
                                variant="contained"
                                onClick={() => trackPromise(calculateMonthlyBalance(null, null))}
                              >
                                {isStartBalanceEstimationExecution ? "Pending" : "Estimate Balance Payment"}
                              </Button>
                            </Box>
                            : null
                        }
                        {
                          isBalanceEstimationCompleted === true ?
                            <Box display="flex" justifyContent="flex-end" p={2}>
                              <Button
                                color="primary"
                                type="button"
                                variant="contained"
                                onClick={() => trackPromise(getBalancePaymentEstimation())}
                              >
                                View Balance Payment
                              </Button>
                            </Box>
                            : null
                        }
                        {routeWiseBalancePaymentEstimationDetails.length > 0 && !displaySupplierWiseTable ?
                          renderRouteBalanceEstimationDetails(routeWiseBalancePaymentEstimationDetails) :
                          displaySupplierWiseTable ?
                            renderSupplierBalanceEstimationDetails(selectedRouteSupplierWiseBalanceDetails) : null
                        }
                      </CardContent>
                      {routeWiseBalancePaymentEstimationDetails.length > 0 || selectedRouteSupplierWiseBalanceDetails.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                          <Button
                            color="primary"
                            id="btnRecord"
                            type="button"
                            variant="contained"
                            style={{ marginRight: '1rem' }}
                            className={classes.colorApprove}
                            onClick={() => createFile()}
                            size="small"
                          >
                            EXCEL
                          </Button>
                          <ReactToPrint
                            documentTitle={displaySupplierWiseTable ? "Route Wise Balance Payment Detail Report" + ' ' + selectedSearchValues.month + ' - ' + selectedSearchValues.year + ' ' + selectedSearchValues.factoryName + ' ' + selectedSearchValues.routeName : "Route Wise Balance Payment Summary Report" + ' ' + selectedSearchValues.month + ' - ' + selectedSearchValues.year + ' ' + selectedSearchValues.factoryName}
                            trigger={() => (
                              <Button
                                color="primary"
                                id="btnRecord"
                                type="button"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                className={classes.colorCancel}
                                size="small"
                              >
                                PDF
                              </Button>
                            )}
                            pageStyle={getPageMargins()}
                            content={() => componentRef.current}
                          />
                          <style>
                          </style>
                          {<div hidden={true}>
                            <CreatePDF
                              ref={componentRef}
                              selectedSearchValues={selectedSearchValues}
                              supplierWiseData={selectedRouteSupplierWiseBalanceDetails}
                              routeWiseData={routeWiseBalancePaymentEstimationDetails}
                              dataType={displaySupplierWiseTable ? "supplierWise" : "routeWise"}
                            />
                          </div>}
                        </Box> : null}
                    </PerfectScrollbar>
                  </Card>
                </Box>
              </form>
            )}
          </Formik>
        </Container>
        <Dialog
          open={openWaitingAnimation}
          maxWidth="sm"
          fullWidth
          PaperProps={{ style: { borderRadius: 20, padding: "16px 8px", boxShadow: "0 8px 24px rgba(0,0,0,0.15)", background: "linear-gradient(135deg, #fafafa 0%, #f5f5f5 100%)" } }}>
          <Card
            elevation={0}
            style={{ borderRadius: 16, padding: "24px 16px", textAlign: "center", backgroundColor: "#fff" }}>
            {!timeOuted ? (
              <>
                <Typography
                  variant="h4"
                  style={{ fontWeight: 700, color: backendProcessDone ? "#2e7d32" : "#1976d2" }}
                  gutterBottom>
                  {backendProcessDone ? "Done!" : "Please Wait!"}
                </Typography>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  gutterBottom>
                  {backendProcessDone ? "Background Process Completed" : "Background Process Running..."}
                </Typography>
                <Box mt={3}>{!backendProcessDone ?
                  <CircularProgress size={60} thickness={4} /> :
                  <CheckCircleOutline style={{ fontSize: 70, color: "#2e7d32" }} />}
                </Box>
              </>
            ) : (
              <>
                <ErrorOutline style={{ fontSize: 70, color: "#d32f2f" }} />
                <Typography
                  variant="h4"
                  style={{ fontWeight: 700, color: "#d32f2f" }}
                  gutterBottom>
                  Process Failed!
                </Typography>
                <Typography
                  variant="h6"
                  color="textSecondary"
                  gutterBottom>
                  Request timed out
                </Typography>
                <Box mt={3}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    style={{ borderRadius: 8, textTransform: "none", padding: "8px 24px", fontWeight: 600 }}
                    onClick={() => window.location.reload()}>
                    Try Again
                  </Button>
                </Box>
              </>
            )}
          </Card>
        </Dialog>
      </Page>
    </Fragment>
  );
};
